import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAudienceRows: [],
  isFromSelectedStep: false,
  campaignData: {},
  selectedTemplate: {},
  campaignEditData:{},
  openTempleteCreationDialog:false,
  previewTemplete:false,
  formTemplateCampainPage:{},
  createCampainOpenDialog:false,
  createAutomationDialog:false,
  cardContent:'',
  tagType:'communications',
  automationEditData:{}
};

export const communicationSlice = createSlice({
  name: "communication",
  initialState,
  reducers: {
    setSelectedAudienceRows: (state, action) => {
      state.selectedAudienceRows = action?.payload;
      return state;
    },
    setIsFromSelectedStep: (state, action) => {
      state.isFromSelectedStep = action?.payload;
      return state;
    },
    setDataAfterCreatedCampaign: (state, action) => {
      state.campaignData = action?.payload;
      return state;
    },
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action?.payload;
      return state;
    },
    setOpenTemplateCreationDialog: (state, action) => {
      state.openTempleteCreationDialog = action?.payload;
      return state;
    },
    setPreviewTemplete: (state, action) => {
      state.previewTemplete = action?.payload;
      return state;
    },
    setFormTemplateCampainPage: (state, action) => {
      state.formTemplateCampainPage = action?.payload;
      return state;
    },
    setCreateCampaignDialog: (state, action) => {
      state.createCampainOpenDialog = action?.payload;
      return state;
    },
    setCreateAutomationDialog: (state, action) => {
      state.createAutomationDialog = action?.payload;
      return state;
    },
    setCardContent: (state, action) => {
      state.cardContent = action?.payload;
      return state;
    },
    setCampaignEditData: (state, action) => {
      state.campaignEditData = action?.payload;
      return state;
    },
    setAutomationEditData: (state, action) => {
      state.automationEditData = action?.payload;
      return state;
    },
    //communication settings
    setTagType: (state, action) => {
      state.tagType = action?.payload;
      return state;
    },
  },
});

export const {
  setSelectedAudienceRows,
  setIsFromSelectedStep,
  setDataAfterCreatedCampaign,
  setSelectedTemplate,
  setOpenTemplateCreationDialog,
  setPreviewTemplete,
  setFormTemplateCampainPage,
  setCreateCampaignDialog,
  setCampaignEditData,
  setCardContent,
  setTagType,
  setCreateAutomationDialog,
  setAutomationEditData
} = communicationSlice.actions;

export default communicationSlice.reducer;
